import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { num, pct, share } from "./format";

const TOP_CLIENTS = 5;
const TOP_GROUPS = 8;

export const ClientDistribution = ({ data, loading, onPick }) => {
  const rows = data?.rows || [];
  const total = rows.reduce((sum, r) => sum + r.employees, 0);
  const top = rows.slice(0, TOP_CLIENTS);
  const rest = rows.slice(TOP_CLIENTS);
  const restCount = rest.reduce((sum, r) => sum + r.employees, 0);
  const maxShare = Math.max(1, ...top.map((r) => r.share_pct), share(restCount, total));

  return (
    <div className={`a2-card ${loading ? "a2-loading" : ""}`}>
      <div className="a2-card-head">
        <div>
          <h3 className="a2-card-title">Employees by Client</h3>
          <div className="a2-card-sub">
            {num(rows.length)} clients · share of {num(total)} employees
          </div>
        </div>
      </div>
      {top.map((r) => (
        <div className="a2-barrow" key={r.id || "none"} style={{ cursor: r.id ? "pointer" : "default" }} onClick={() => r.id && onPick(r)}>
          <div>
            <div className="a2-name" style={{ fontWeight: 600 }}>{r.name}</div>
            <div className="a2-card-sub">
              {num(r.employees)} employees · {pct(r.attendance_pct)} attendance
            </div>
          </div>
          <div className="a2-meter">
            <span className="fill-indigo" style={{ width: `${(r.share_pct * 100) / maxShare}%` }} />
          </div>
          <div className="num">{pct(r.share_pct)}</div>
          <div />
        </div>
      ))}
      {rest.length > 0 && (
        <div className="a2-barrow">
          <div>
            <div style={{ fontWeight: 600 }}>Others ({rest.length} clients)</div>
            <div className="a2-card-sub">{num(restCount)} employees</div>
          </div>
          <div className="a2-meter">
            <span className="fill-grey" style={{ width: `${(share(restCount, total) * 100) / maxShare}%` }} />
          </div>
          <div className="num">{pct(share(restCount, total))}</div>
          <div />
        </div>
      )}
      {!loading && rows.length === 0 && <div className="a2-empty">No clients in this view.</div>}
      {data?.lowest?.length > 0 && (
        <div style={{ borderTop: "1px solid var(--a2-border)", marginTop: 10, paddingTop: 12 }}>
          <div className="a2-barrow-head">Lowest attendance</div>
          <div className="a2-lowest">
            {data.lowest.map((r) => (
              <span key={r.id || "none"}>
                <WarningAmberIcon style={{ fontSize: 15, color: "var(--a2-red)", marginRight: 4, verticalAlign: -3 }} />
                {r.name}
                <b>{pct(r.attendance_pct)}</b>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const DISTRIBUTION_TABS = [
  { id: "designation", label: "Designation" },
  { id: "shift", label: "Shift" },
  { id: "client", label: "Client" },
];

export const WorkforceDistribution = ({ data, loading, by, onBy }) => {
  const rows = (data?.rows || []).slice(0, TOP_GROUPS);
  const max = Math.max(1, ...rows.map((r) => r.employees));
  const label = DISTRIBUTION_TABS.find((t) => t.id === by)?.label;
  const showManpower = rows.some((r) => r.total_manpower !== null && r.total_manpower !== undefined);

  return (
    <div className={`a2-card ${loading ? "a2-loading" : ""}`}>
      <div className="a2-card-head">
        <div>
          <h3 className="a2-card-title">Workforce Distribution</h3>
          <div className="a2-card-sub">Headcount and attendance % within the current view</div>
        </div>
      </div>
      <div className="a2-seg a2-noprint" style={{ marginBottom: 12 }}>
        {DISTRIBUTION_TABS.map((t) => (
          <button key={t.id} className={by === t.id ? "active" : ""} onClick={() => onBy(t.id)}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="a2-barrow a2-barrow-head">
        <div>{label}</div>
        <div>Headcount</div>
        <div className="num">{showManpower ? "Count / MP" : "Count"}</div>
        <div className="num">Attend.</div>
      </div>
      {rows.map((r) => (
        <div className="a2-barrow" key={r.id ?? r.name}>
          <div style={{ fontWeight: 500 }}>{r.name}</div>
          <div className="a2-meter">
            <span className="fill-indigo" style={{ width: `${(r.employees * 100) / max}%` }} />
          </div>
          <div className="num" title={showManpower ? "Employees / total manpower" : undefined}>
            {num(r.employees)}
            {showManpower && <span className="t-grey"> / {r.total_manpower ? num(r.total_manpower) : "–"}</span>}
          </div>
          <div className={`num ${r.attendance_pct >= 80 ? "t-green" : "t-red"}`}>{pct(r.attendance_pct)}</div>
        </div>
      ))}
      {!loading && rows.length === 0 && <div className="a2-empty">No data in this view.</div>}
    </div>
  );
};
